module.exports = __webpack_public_path__ + "static/media/bg_package.ee731831.png";